import {registerClassForPersistence, registerMapping, registerMigration} from '@trullock/firebase-common'


import UserView from './users/userView.js';
import UserLite from './users/userLite.js';
import PendingCertificationAttempt from './users/pendingCertificationAttempt.js';
import PendingMAPAttempt from './users/pendingMAPAttempt.js';
import MembershipNumber from './users/membershipNumber.js';
import RocketView from './rockets/rocketView.js';
import UserSearch from './users/userSearch.js';
import ScoreBoard from './map/scoreboard.js';
import DateTime from '../lib/dateTime.js';
import StripeSessionView from './users/stripeSessionView.js';
import EmailCampaignView from './emailCampaigns/emailCampaignView.js';
import ClubView from './clubs/clubView.js';
import ClubCalendarView from './clubs/clubCalendarView.js';
import PricingModel from './clubs/pricingModel.js';
import ExtraPricingModel from './clubs/extraPricingModel.js';
import TrackedFlightView from './tracking/trackedFlightView.js';
import PendingRecordAttempt from './users/pendingRecordAttempt.js';
import RecordsHallOfFame from './records/recordsHallOfFame.js';
import MotorsInventoryView from './inventory/motorsInventoryView.js';
import TPSTeamView from './tps/tpsTeamView.js';
import Fulfillment from './users/fulfillment.js';

/// DateTimes
registerMapping((key, value) => {
    if(value instanceof DateTime)
        return value.valueOf()
    return undefined;
}, (key, value) => {
    if((key.substr(key.length - 2, 2) == 'On') && typeof value == 'number')
    {
        let datetime = new DateTime(value);
        return datetime;
    }

    return undefined;
})

registerClassForPersistence(UserView, [
	{ 
		type: UserView.Certification.Stage,
		property: 'passedOn'
	},
	{ 
		type: UserView,
		property: 'birthday'
	}
]);
registerClassForPersistence(UserLite);
registerClassForPersistence(UserSearch);

registerClassForPersistence(PendingCertificationAttempt);
registerClassForPersistence(PendingMAPAttempt);
registerClassForPersistence(PendingRecordAttempt);

registerClassForPersistence(MembershipNumber);

registerClassForPersistence(RocketView);

registerClassForPersistence(StripeSessionView);

registerClassForPersistence(ScoreBoard);
registerClassForPersistence(RecordsHallOfFame);

registerClassForPersistence(EmailCampaignView);

registerClassForPersistence(ClubView);
registerClassForPersistence(ClubCalendarView);
registerClassForPersistence(PricingModel);
registerClassForPersistence(ExtraPricingModel);

registerClassForPersistence(TPSTeamView);

registerClassForPersistence(TrackedFlightView);

registerClassForPersistence(MotorsInventoryView);

registerClassForPersistence(Fulfillment);


// TODO: EventReport?

// map2, can be killed because only people with this data should be testers
registerMigration((key, parent, value, dest, type) => key == "map2" && (parent._type == "User" || parent._type == "UserLite" || parent._type == "UserView"), (key, parent, value, dest, type) => undefined)
/// old map
registerMigration((key, parent, value, dest, type) => key == "map" && value.attemptPending === undefined && (parent._type == "User" || parent._type == "UserLite" || parent._type == "UserView"), (key, parent, value, dest, type) => undefined)
/// old avatars
registerMigration((key, parent, value, dest, type) => (key == "userAvatar" || key == 'avatar') && value?.indexOf('multiavatar.com') > -1, (key, parent, value, dest, type) => value.replace('https://api.multiavatar.com/', '/api/user-avatar?id=').replace('.svg', ''))

// insurance properties
registerMigration((key, parent, value, dest, type) => (type == UserView || type == UserLite) && key == "BMFANumber", (key, parent, value, dest, type) => {
	dest.insurance.BMFANumber = value;
	return undefined;
})
registerMigration((key, parent, value, dest, type) => type == UserView && key == "BMFASurname", (key, parent, value, dest, type) => {
	dest.insurance.BMFASurname = value;
	return undefined;
})

// TODO: temporary until data is migrated
registerMigration(
	(key, parent, value, dest, type) => type == UserView.MAP && key == "isAssessor", 
	(key, parent, value, dest, type) => {
		dest.assessorStatus = value ? 'passed' : 'none'
		return undefined;
	}
)

// delay -> ejections
registerMigration((key, parent, value, dest, type) => type == RocketView.Flight && key == "delay", (key, parent, value, dest, type) => {
	dest.ejections = value !== null ? value + 's' : null;
	return undefined;
})

// motors string -> array
registerMigration((key, parent, value, dest, type) => type == RocketView.Flight && key == "motors" && typeof value == 'string', (key, parent, value, dest, type) => {
	return [{
		inventoryId: null,
		name: value
	}]
})

// bonus.diy-plastic-chute -> bonus.diy-simple-chute
registerMigration((key, parent, value, dest, type) => type == RocketView.Flight && key == "mapTasks" && value?.indexOf('bonus.diy-plastic-chute') > -1, (key, parent, value, dest, type) => {
	value[value.indexOf('bonus.diy-plastic-chute')] = 'bonus.diy-simple-chute'
	return value;
})

// Add missing class serialisations and move opens from a single record to an array
registerMigration((key, parent, value, dest, type) => type == EmailCampaignView && key == "recipients", (key, parent, value, dest, type) => {
	Object.values(value).forEach(v => {
		if(!v._type)
			// TODO: expose and use serialiseClassName
			v._type = 'EmailCampaignView.Recipient'

		if(v.openedOn)
		{
			if(!v.opens)
				v.opens = [];

			v.opens.push({
				// TODO: expose and use serialiseClassName
				_type: 'EmailCampaignView.Recipient.Open',
				openedOn: v.openedOn,
				userAgent: v.openedUserAgent
			})
		}

		delete v.openedOn;
		delete v.openedUserAgent;
	})
	return value;
})
